import IsServerSideRendering from './IsServerSideRendering';

const navigationMenuPaths = {
  cars: [
    /^(\/cars)$/,
    /^(\/serenity)$/,
  ],
  search: [
    /^(\/search)$/,
  ],
  vdp: [
    /^(\/search\/)/,
    /^(\/details\/)/,
    /^(\/ondemand\/)/,
    /^(\/vehicle\/)/,
  ],
  trades: [
    /^(\/sellyourcar).*/,
  ],
  finance: [
    /^(\/learn-financing)$/,
    /^(\/get-approved).*/,
    /^(\/softpull-ui).*/,
    /^(\/financing-prequalification).*/,
    /^(\/auto-loan-calculator)$/,
  ],
  carFinder: [
    /^(\/help-me-search).*/,
  ],
  acquisition: [
    /^(\/acquisition).*/,
    /^(\/procurement).*/,
    /^(\/purchase).*/
  ]
};

const GetActiveMenuName = () => {
  if (IsServerSideRendering) return null;

  const urlPath = window.location.pathname;
  const navigationMenuPathNames = Object.keys(navigationMenuPaths);

  for (let i = 0; i < navigationMenuPathNames.length; i += 1) {
    const menuPathName = navigationMenuPathNames[i];
    const pathsToCheck = navigationMenuPaths[menuPathName];

    for (let j = 0; j < pathsToCheck.length; j += 1) {
      if (urlPath.match(pathsToCheck[j])) {
        return menuPathName;
      }
    }
  }

  return '';
};

export default GetActiveMenuName;
